export namespace CustomEvents {

    const subscriptions: { [event: string]: Array<(eventArgs?: any) => void> } = {};

    export function subscribe(eventName: string, handler: (eventArgs?: any) => void): void {
        if (Object.prototype.hasOwnProperty.call(subscriptions, eventName)) {
            subscriptions[eventName].push(handler);
        } else {
            subscriptions[eventName] = [handler];
        }
    }

    export function unsubscribe(): void {
        // TODO: Implement
        throw new Error('Function not implemented');
    }

    export function unsubscribeAll(eventName: string): void {
        subscriptions[eventName] = [];
    }

    export function sendEvent(eventName: string, eventArgs?: any): number {
        let subscribers: Array<(eventArgs?: any) => void> = [];
        for (const event in subscriptions) {
            if (event === eventName) {
                subscribers = subscriptions[event];
                break;
            }
        }

        subscribers.forEach((callback: (eventArgs?: any) => void) =>
            callback(eventArgs));

        return subscribers.length;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/custom-events.ts